import React from 'react';
import { Character as StyledCharacter } from '../styles/StyledComponents';

interface CharacterProps {
  isJumping: boolean;
  isSliding: boolean;
}

const Character: React.FC<CharacterProps> = ({ isJumping, isSliding }) => {
  return (
    <StyledCharacter 
      isJumping={isJumping} 
      isSliding={isSliding} 
    />
  );
};

export default Character;
